 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React, {Suspense} from 'react'
import {useFragment} from 'react-relay'
import MockScopingList from '~/modules/meeting/components/MockScopingList'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import gitlabScopingSearchResultsQuery, {

} from '../__generated__/GitLabScopingSearchResultsQuery.graphql'

import GitLabScopingSearchResults from './GitLabScopingSearchResults'





export const gitlabIssueArgs = {
  sort: 'UPDATED_DESC',
  state: 'opened'
} 

const GitLabScopingSearchResultsRoot = (props) => {
  const {meetingRef} = props
  const meeting = useFragment(
    graphql`
      fragment GitLabScopingSearchResultsRoot_meeting on PokerMeeting {
        ...GitLabScopingSearchResults_meeting
        gitlabSearchQuery {
          queryString
          selectedProjectsIds
        }
        teamId
      }
    `,
    meetingRef
  )
  const {teamId, gitlabSearchQuery} = meeting
  const {queryString, selectedProjectsIds} = gitlabSearchQuery
  const normalizedQueryString = queryString.trim()
  const normalizedSelectedProjectsIds = _optionalChain([selectedProjectsIds, 'optionalAccess', _ => _.length])
    ? (selectedProjectsIds )
    : null
  const queryRef = useQueryLoaderNow(
    gitlabScopingSearchResultsQuery,
    {
      teamId,
      queryString: normalizedQueryString,
      selectedProjectsIds: normalizedSelectedProjectsIds,
      ...gitlabIssueArgs
    }
  )
  return (
    React.createElement(Suspense, { fallback: React.createElement(MockScopingList, null ),}
      , queryRef && React.createElement(GitLabScopingSearchResults, { queryRef: queryRef, meetingRef: meeting,} )
    )
  )
}

export default GitLabScopingSearchResultsRoot
